import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { iFilterReviewData, Review } from '../../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReviewService {

  constructor(
    private http: HttpClient
  ) { }

  public getAll(data: iFilterReviewData) {
    let queries = '?ordering=' + (data.desc ? '-created_at' : 'created_at');
    queries = queries + '&page=' + (data.page || 1) + '&page_size=' + (data.page_size || 10);

    return this.http.get<{
      code: string;
      data: {
        count: number,
        results: Array<Review>
      }
    }>(`${environment.host}/review/${data.orgId}${queries}`);
  }

  public getAllBySpecialistId(specialist_id: string) {
    return this.http.get<{
      code: string;
      data: {
        count: number,
        results: Array<Review>
      }
    }>(`${environment.host}/review/specialist/${specialist_id}`);
  }
}
